module.exports = __webpack_public_path__ + "media/img/corporate/Illustration/Mockup/Data/Desktop-6083890bc623b60650af4771802197e6.png";